import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ScheduleEvent } from 'src/app/core/models/user.modal';

@Component({
  selector: 'app-schedules-reminder',
  templateUrl: './schedules-reminder.page.html',
  styleUrls: ['./schedules-reminder.page.scss'],
})
export class SchedulesReminderPage implements OnInit {

  constructor(
    private modalController: ModalController,
  ) { }

  @Input() schedules: Array<ScheduleEvent> = [];

  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss();
  }

}
